import { SECTION_BACKGROUND } from './flexibleContent.type';

export const getSectionClasses = (
  background: SECTION_BACKGROUND = 'white',
  type: 'default' | 'article' | 'contentHub' = 'default',
): string => ['c-se', `c-se--${background ?? 'white'}`, `c-se--${type}`].join(' ');
